import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { TerminatePoolDto } from '../../types/pool-plans.types';
import { toBackendDateFormat } from '../../utils/to-backend-date-format.util';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useTerminate = () => {
  const { mutate: terminate, isPending } = useIdempotentAppMutation(
    [QueryKey.TERMINATE_SHARE_PLAN],
    {
      mutationFn: (
        { date, planId, companyId }: { companyId: string; date: Date; planId: string },
        { headers },
      ) =>
        ApiService.patch<unknown, TerminatePoolDto>(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'share-plans', planId, 'terminate'],
          },
          { body: { date: toBackendDateFormat(date) }, headers },
        ),
    },
  );
  return { terminate, isPending };
};
